import { render, staticRenderFns } from "./GestioneAzienda.vue?vue&type=template&id=05f2a8a7&"
import script from "./GestioneAzienda.vue?vue&type=script&lang=js&"
export * from "./GestioneAzienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports